<template>
  <div class="sign">
    <navBar />
    <div class="field-group">
        <van-field v-model="formData.name" label="用户名" placeholder="请输入用户名" class="civa-bor-b" />
        <van-field v-model="formData.mobile" type="tel" maxLength="11" label="手机号" placeholder="请输入您的手机号码" class="civa-bor-b" />
        <van-field v-model="formData.verificationCode" maxLength="6" label="验证码" placeholder="请输入验证码" class="civa-bor-b">
            <van-button slot="button" @click="sendVercode">{{sendSmsText}}</van-button>
        </van-field>
        <van-field v-model="formData.organization" label="学校名称" placeholder="请输入学校名称" class="civa-bor-b" />
        <van-cell class="cell civa-bor-b" title="地址" size="large" @click="chooseArea">
            <div class="van-field__control" v-if="formData.province">
                {{formData.province}} {{formData.city}} {{formData.district}}
            </div>
            <div class="placeholder" v-else>请选择地址</div>
            <div slot="right-icon"><img class="arrow-right" src="https://restaskimg.civaonline.cn/imagesH5/home/right-arrow.png" alt=""></div>
        </van-cell>
        <van-field v-model="formData.scale" label="在读人数" readonly placeholder="请选择在读人数" class="civa-bor-b" @click.native="chooseScale" />
        <van-field v-model="formData.referrer" label="推荐人姓名" placeholder="请输入推荐人姓名（选填）" class="civa-bor-b mar-t" />
        <van-field v-model="formData.referrerMobile" label="推荐人手机" placeholder="请输入推荐人手机（选填）" class="civa-bor-b" />
    </div>
      <div :class="['confirm-btn', {'can-btn' :canSubmit}]" @click="confirm">提交</div>
      <van-popup v-model="showScale" position="bottom">
          <van-picker :columns="columns" @change="onChange" />
      </van-popup>
      <area-picker :areaPickerVisible="areaPickerVisible" @chooseAreaItem="chooseAreaItem"></area-picker>
  </div>
</template>

<script>
import navBar from '@/components/navBar';
import areaPicker from '@/components/areaPicker'
import { userSign, sendVerificationCode } from '@/api/signup'
import { validatMobile } from '@/utils/tools'
import Vue from 'vue'
import { Cell, Field, Button, Area, Picker } from 'vant';
Vue.use(Field).use(Button).use(Cell).use(Area).use(Picker);
export default {
  components: {
    navBar, areaPicker,
  },
  data() {
    return {
      formData: {
        name: '',
        mobile: '',
        verificationCode: '123456',
        organization: '',
        province: '',
        city: '',
        district: '',
        scale: '',
        referrer: '',
        referrerMobile: '',
      },
      ifSendSms: false,
      sendSmsText: '发送验证码',
      timer: null,
      areaPickerVisible: false,
      showScale: false,
      columns: ['在读人数<50人', '在读人数<200人', '在读人数<500人', '在读人数<1000人', '湖在读人数<5000人州', '在读人数>5000人'],
    }
  },
  computed: {
    canSubmit() {
      if (this.formData.name && validatMobile(this.formData.mobile) &&
        this.formData.verificationCode.length === 6 && this.formData.organization &&
        this.formData.province && this.formData.city && this.formData.district && this.formData.scale) {
        return true
      }
      return false;
    },
  },
  methods: {
    // 提交申请
    confirm() {
      if (!this.canSubmit) {
        return
      }
      userSign(this.formData).then(res => {
        if (res.returnNo === '0060') {
          this.$router.push({ path: '/signupSuc' });
        } else {
          this.$toast({
            message: res.returnInfo || 'error',
            duration: 3 * 1000,
          })
        }
      })
    },
    // 接口获取验证码
    doSendSms() {
      sendVerificationCode({ mobile: this.formData.mobile }).then( res => {
        if (res.returnNo !== '0000') {
          this.$toast('验证码获取失败');
        }
      })
    },
    // 点击发送验证码
    sendVercode() {
      if (!validatMobile(this.formData.mobile)){
        this.$toast('手机号码有误');
        return;
      }
      if (this.ifSendSms) {
        return;
      }
      this.ifSendSms = true;
      this.doSendSms();
      let time = 60;
      this.timer = setInterval(() => {
        time--;
        this.sendSmsText = time + 's';
        if (time <= 0) {
          clearInterval(this.timer);
          this.ifSendSms = false;
          this.sendSmsText = '发送验证码';
          return;
        }
      }, 1000);
    },
    // 选择地址
    chooseArea() {
      this.areaPickerVisible = true;
    },
    // 选择在读人数
    chooseScale() {
      this.showScale = true;
    },
    // 选择地址后赋值
    chooseAreaItem(arr, val) {
      if (arr) {
        this.formData.province = arr[0].name;
        this.formData.city = arr[1].name;
        this.formData.district = arr[2].name;
      }
      this.areaPickerVisible = val;
    },
    // 在读人数赋值
    onChange(picker, value) {
      this.formData.scale = value;
      setTimeout(() => {
        this.showScale = false;
      }, 500);
    },
  },
}
</script>

<style scoped lang="less">
.sign{
    width: 100%;
    height: 100vh;
    background: #F6F7FB;
    .field-group{
        margin-top: 20px;
    }
    .civa-bor-b{
        border-bottom: 1px solid rgba(108,123,138,.08);
    }
    .mar-t{
        margin-top: 15px;
    }
    .arrow-right {
        width: 12px;
        display: block;
    }
    .confirm-btn{
        width: 600px;
        height: 80px;
        margin: 100px auto;
        font-size: 30px;
        line-height: 80px;
        text-align: center;
        border-radius: 40px;
        background: #ccc;
        color: #ffffff;
    }
    .can-btn{
        background-image: linear-gradient(90deg, #FF9233 0%, #FF7E41 100%);
    }
}
</style>
